import { useForm } from 'react-hook-form';
import LoanApplicationFactory from '../../../domain/newLoanApplication/LoanApplicationFactory';
import Collection from '../../../domain/valueObject/Collection';
import { NewLoanApplicationStepsProps } from '../../../pages/NewLoanApplication';
import { NewLoanSteps } from '../../../utils/enums';
import PartInputField from '../../parts/PartInputField';
import BlockStepsButtons from '../BlockStepsButtons';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';

interface RehabAmountSpendProps extends NewLoanApplicationStepsProps {}

const RehabAmountSpend = ({
    nextStep,
    prevStep,
    newLoanEntity
}: RehabAmountSpendProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        resolver: yupResolver(
            yup.object().shape({
                rehabAmountSpentToDate: yup
                    .string()
                    .required('Please complete this required field.')
                    .matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        'You must specify a number.'
                    )
            })
        )
    });

    const onSubmit = (data: any) => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(data)
        );
        nextStep(NewLoanSteps.EXISTING_DEBT);
    };

    const handlePrevStep = () => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(getValues())
        );
        prevStep(NewLoanSteps.ORIGINAL_PURCHASE_PRICE);
    };

    useEffect(() => {
        newLoanEntity.hasRehabAmountSpendToDate() &&
            setValue(
                'rehabAmountSpentToDate',
                newLoanEntity.rehabAmountSpendToDate.value
            );
    }, []);

    return (
        <div className="login">
            <div className="container">
                <h1 className="login__title">
                    How much did you spend on renovating your property?
                </h1>
                <p className="login__subtitle login__subtitle--middle">
                    Renovations Costs Spent Amount
                </p>
                <div className="login__box">
                    <PartInputField
                        label="Rehab Amount Spent To Date"
                        name="rehabAmountSpentToDate"
                        control={control}
                        errors={errors}
                        isRequired
                        isDollarAmount={true}
                    />
                    <BlockStepsButtons
                        prevStep={handlePrevStep}
                        nextStep={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default RehabAmountSpend;
